export default __webpack_public_path__ + "static/media/sampleQbCoaFile.0bcaeba3.xlsx";